module.exports = __webpack_public_path__ + "images/dimensions-83f3cecbf083ee8d91d9fdeec58d39ca.jpg";